import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background" data-testid="payment-cancel-page">
      <div className="max-w-md w-full text-center space-y-6 fade-up">
        <XCircle className="h-16 w-16 mx-auto text-red-500" />
        <h1 className="font-display text-4xl font-black tracking-tighter">Pagamento annullato</h1>
        <p className="text-muted-foreground">Nessun addebito effettuato.</p>
        <Link to="/dashboard/subscription">
          <Button className="pill-btn bg-primary text-primary-foreground hover:bg-[hsl(var(--accent))]" data-testid="pc-retry-btn">
            Riprova
          </Button>
        </Link>
      </div>
    </div>
  );
}
